import bookingManagerListComponent from './booking-manager-list.component';

const bookingManagerListModule = angular
  .module('bookingManagerList', [])
  .component('bookingManagerList', bookingManagerListComponent);

export default bookingManagerListModule;



/** WEBPACK FOOTER **
 ** ./frontend/components/booking/booking-manager-list/booking-manager-list.js
 **/